var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [_c("h2", [_vm._v("Diário")])]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.goDespesas()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-dollar-sign" }),
                  _vm._v(" Mostrar\n                Despesas")
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.goRotas()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-map" }), _vm._v(" Voltar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-card",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-card-header",
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-h": "center", "align-v": "end" } },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-calendar", {
                                staticClass: "border mt-2",
                                attrs: {
                                  disabled: _vm.loading,
                                  block: "",
                                  "label-help": "",
                                  "hide-header": "",
                                  "nav-button-variant": "primary",
                                  "today-variant": "danger"
                                },
                                on: { selected: _vm.onContext },
                                model: {
                                  value: _vm.calendario,
                                  callback: function($$v) {
                                    _vm.calendario = $$v
                                  },
                                  expression: "calendario"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-card",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _vm.calendario
                                          ? _c("span", [
                                              _vm._v(" Data Selecionada: "),
                                              _c("b", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.dataSelecionadaFormatada
                                                    ) +
                                                    "\n                                            "
                                                )
                                              ])
                                            ])
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Usuário")
                                          ]),
                                          _vm._v(" "),
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "sm",
                                              options: _vm.listUsuarios
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onContext()
                                              }
                                            },
                                            model: {
                                              value: _vm.filtro.usuario,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtro,
                                                  "usuario",
                                                  $$v
                                                )
                                              },
                                              expression: "filtro.usuario"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-3" },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Motivo")
                                          ]),
                                          _vm._v(" "),
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "sm",
                                              options: _vm.optionsMotivo
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onContext()
                                              }
                                            },
                                            model: {
                                              value: _vm.filtro.motivo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtro,
                                                  "motivo",
                                                  $$v
                                                )
                                              },
                                              expression: "filtro.motivo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-3" },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Status")
                                          ]),
                                          _vm._v(" "),
                                          _c("b-form-select", {
                                            attrs: {
                                              size: "sm",
                                              options: _vm.optionsStatus
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.onContext()
                                              }
                                            },
                                            model: {
                                              value: _vm.filtro.status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtro,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "filtro.status"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-3" },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "primary",
                                                size: "sm",
                                                title: "Buscar"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onContext()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-search"
                                              }),
                                              _vm._v("Buscar")
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-v": "end" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c("b-form-select", {
                                staticClass: "md-2 col-md-2",
                                attrs: {
                                  id: "per-page-select",
                                  options: _vm.pageOptions,
                                  size: "sm"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getRoteiros()
                                  }
                                },
                                model: {
                                  value: _vm.perPage,
                                  callback: function($$v) {
                                    _vm.perPage = $$v
                                  },
                                  expression: "perPage"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "text-center", attrs: { md: "6" } },
                            [
                              _vm._v(
                                " Total de Visitas: " +
                                  _vm._s(_vm.total_row) +
                                  " "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { "align-h": "end", md: "3" } },
                            [
                              _vm.total_row > 4
                                ? _c("b-pagination", {
                                    attrs: {
                                      size: "sm",
                                      fill: "",
                                      disabled: _vm.loading,
                                      "total-rows": _vm.total_row,
                                      "per-page": _vm.perPage
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.getRoteiros()
                                      }
                                    },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-table", {
                                attrs: {
                                  busy: _vm.loading,
                                  items: _vm.roteiros,
                                  fields: _vm.fields,
                                  small: "",
                                  hover: "",
                                  striped: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "table-busy",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-center text-primary my-2"
                                          },
                                          [
                                            _c("b-spinner", {
                                              staticClass: "align-middle",
                                              attrs: { small: "" }
                                            }),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v("Carregando...")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function(row) {
                                      return [
                                        row.item.status == "ABERTO"
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "success",
                                                  size: "sm",
                                                  title: "Aprovar"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.aprovar(row.item)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-thumbs-up"
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("h4", [
                    _vm._v(
                      "Adicionar visita em: " +
                        _vm._s(_vm.dataSelecionadaFormatada)
                    )
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.saveVisita()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-save" }), _vm._v(" Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalVisita = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalVisita,
            callback: function($$v) {
              _vm.modalVisita = $$v
            },
            expression: "modalVisita"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Consultor")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { options: _vm.listUsuarios },
                            model: {
                              value: _vm.visita.consultor,
                              callback: function($$v) {
                                _vm.$set(_vm.visita, "consultor", $$v)
                              },
                              expression: "visita.consultor"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Motivo")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { options: _vm.optionsMotivo },
                            model: {
                              value: _vm.visita.motivo,
                              callback: function($$v) {
                                _vm.$set(_vm.visita, "motivo", $$v)
                              },
                              expression: "visita.motivo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Nome do(a) Cliente")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { placeholder: "Digite o nome" },
                            model: {
                              value: _vm.visita.cliente,
                              callback: function($$v) {
                                _vm.$set(_vm.visita, "cliente", $$v)
                              },
                              expression: "visita.cliente"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [_vm._v("Obs")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            attrs: {
                              id: "textarea",
                              placeholder: "Observações",
                              rows: "3",
                              "max-rows": "6"
                            },
                            model: {
                              value: _vm.visita.obs,
                              callback: function($$v) {
                                _vm.$set(_vm.visita, "obs", $$v)
                              },
                              expression: "visita.obs"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c119c59", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c119c59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Diario.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c119c59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Diario.vue
// module chunks = 2